import { Container } from '@mui/material';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const EMPTY_OBJ = {};

export const PageWrapper = styled.div`
	flex-grow: 1;
	position: relative;
	display: inline-block;
	width: 100%;
	height: 100%;
`;

export type PageProps = PropsWithChildren<{
	fullscreen?: boolean;
	/** marginTop - used in case if we want extra page margin. Our page by default
	 * has margin 0 - designed to stay all the way up & take all available space */
	marginTop?: 'small' | 'medium' | 'large';
}>;
const pageMarginTop = {
	small: '0.5rem',
	medium: '1rem',
	large: '2rem'
};

export const PageBackground = styled.div`
	background-color: #f5f5f5;
	width: 100%;
	height: 100%;
	position: fixed;
`;

export const Page: React.FC<PageProps> = props => {
	return (
		<>
			<PageBackground />
			{props.fullscreen ? (
				<PageWrapper style={props.marginTop ? { marginTop: pageMarginTop[props.marginTop] } : EMPTY_OBJ}>
					{props.children}
				</PageWrapper>
			) : (
				<PageWrapper style={props.marginTop ? { marginTop: pageMarginTop[props.marginTop] } : EMPTY_OBJ}>
					<Container maxWidth="xl">{props.children}</Container>
				</PageWrapper>
			)}
		</>
	);
};
